import styled  from "styled-components";

export const Input = styled.input
      `
      font-family: 'SuncheonB';
      width: 200px;
      height: 50px;
      border-radius: 9px;
      margin:1rem;

      `
      
export const MessageButton = styled.span
      `
      cursor: pointer;
      margin-left : 0.1rem;
      font-size: 15px;
      `
      
export const Form = styled.form
      `
      margin-bottom: 10px;
      
      `
      ;

export const InputWrapper = styled.div
      `
       flex:0.3;
      `;
export const Emojimerong = styled.span
      `
         cursor:pointer;
         font-size:20px;
      `;